export const services = {
  it: {
    meta: {
      seoTitle: "Servizi — Power Platform, Dati e Automazione per PMI | Victor Lazari",
      seoDescription:
        "Progetti a prezzo fisso per PMI e system integrator: app gestionali Power Apps, dashboard Power BI, automazione processi e integrazioni dati. Ex Baker Hughes. Ravenna e remoto.",
    },
    hero: {
      eyebrow: "Servizi per PMI e system integrator",
      title: "Progetti concreti, prezzo fisso, consegna in settimane.",
      subtitle:
        "Niente contratti lunghi, niente promesse vaghe. Scegli un problema, lo risolviamo con strumenti che probabilmente hai già (Microsoft 365) e lo misuri dal primo giorno.",
      point1: "Preventivo fisso scritto prima di iniziare",
      point2: "Consegna tipica: 1–3 settimane",
      point3: "Lavoro con le licenze Microsoft che già paghi",
      cta: "Parliamone su WhatsApp",
      ctaSecondary: "Chiamata conoscitiva gratuita",
    },
    offers: {
      title: "Cosa posso fare per la tua azienda",
      subtitle:
        "Quattro interventi a perimetro chiuso: sai cosa ricevi, quanto costa e quando è pronto — prima di firmare.",
      timelineLabel: "Tempi tipici",
      deliverableLabel: "Cosa ricevi",
      items: [
        {
          code: "app",
          name: "App gestionale su misura",
          tagline: "Sostituisci Excel, carta e WhatsApp interni con un'app fatta per il tuo processo.",
          timeline: "2–3 settimane",
          bullets: [
            "Approvazioni ordini, rapportini, non conformità, richieste ferie: il tuo processo, digitalizzato",
            "Costruita con Power Apps sulle licenze Microsoft 365 che hai già",
            "Funziona da telefono, tablet e PC — anche in produzione",
            "Dati centralizzati: fine dei file Excel in 12 versioni diverse",
          ],
          deliverable: "Un'app funzionante usata dal tuo team, con formazione inclusa.",
        },
        {
          code: "dashboard",
          name: "Dashboard Power BI",
          tagline: "Produzione, vendite, margini: i tuoi numeri aggiornati da soli, in una schermata.",
          timeline: "1–2 settimane",
          bullets: [
            "Collegata direttamente al gestionale, a SQL o ai tuoi file Excel",
            "KPI decisi insieme a te: quello che guardi ogni lunedì mattina",
            "Aggiornamento automatico: nessuno deve più 'preparare il report'",
            "Accessibile da ufficio, casa e telefono",
          ],
          deliverable: "Una dashboard live per te e i tuoi responsabili, con dati verificati.",
        },
        {
          code: "automation",
          name: "Automazione di processi e report",
          tagline: "Le attività ripetitive che oggi rubano ore al tuo ufficio, fatte dal software.",
          timeline: "1–2 settimane",
          bullets: [
            "Report periodici generati e inviati da soli (email, Teams, WhatsApp)",
            "Passaggi di dati tra ufficio e produzione senza copia-incolla",
            "Notifiche automatiche: scadenze, soglie, anomalie",
            "Power Automate + integrazioni: in Baker Hughes ho ridotto il lavoro manuale del 60%",
          ],
          deliverable: "Flussi automatici documentati, con ore/uomo risparmiate misurabili.",
        },
        {
          code: "integration",
          name: "Integrazioni e migrazione dati",
          tagline: "I tuoi sistemi che finalmente si parlano: gestionale, e-commerce, produzione.",
          timeline: "2–4 settimane",
          bullets: [
            "Collegamento tra gestionale/ERP, SQL Server, SharePoint e cloud",
            "Migrazione dati pulita: da vecchi sistemi o Excel a un database vero",
            "API e connettori custom dove i software non prevedono integrazione",
            "Esperienza su dati industriali e farmaceutici (tracciabilità inclusa)",
          ],
          deliverable: "Sistemi collegati e dati migrati, con documentazione e test.",
        },
      ],
    },
    integrators: {
      title: "Per system integrator e società di consulenza",
      text:
        "Hai più progetti Power Platform, dati o sviluppo che mani per realizzarli? Lavoro in subappalto o white-label: entro su progetti già venduti, con disponibilità immediata, fatturazione a giornata o a corpo. Italiano, inglese, rumeno e russo per clienti internazionali.",
      bullets: [
        "Power Apps, Power Automate, Power BI, SQL Server, Azure",
        "Disponibilità immediata, anche part-time su più progetti",
        "Esperienza enterprise: Baker Hughes, settore farmaceutico e manifatturiero",
      ],
      cta: "Scrivimi per disponibilità",
    },
    process: {
      title: "Come funziona",
      subtitle: "Tre passaggi, zero sorprese.",
      steps: [
        {
          title: "1. Chiamata gratuita di 30 minuti",
          text: "Mi racconti il problema. Ti dico subito se posso risolverlo, come e in quanto tempo — o ti dico onestamente di no.",
        },
        {
          title: "2. Preventivo fisso scritto",
          text: "Perimetro, cosa ricevi, tempi e prezzo: tutto nero su bianco prima di iniziare. Nessun costo a sorpresa.",
        },
        {
          title: "3. Consegna e formazione",
          text: "Consegno in settimane, non mesi. Formo il tuo team e resto disponibile per assistenza dopo la consegna.",
        },
      ],
    },
    proof: {
      title: "Perché fidarti",
      stats: [
        { value: "200+", label: "processi aziendali critici supportati in Baker Hughes" },
        { value: "−60%", label: "lavoro manuale eliminato con le automazioni" },
        { value: "7+", label: "anni tra manifattura, farmaceutico e automotive" },
        { value: "4", label: "lingue: italiano, inglese, rumeno, russo" },
      ],
      companiesLabel: "Esperienza in aziende come",
    },
    faq: {
      title: "Domande frequenti",
      items: [
        {
          q: "Quanto costa un progetto?",
          a: "Dipende dal perimetro, ma lo sai prima di iniziare: dopo la chiamata gratuita ricevi un preventivo fisso scritto. La maggior parte dei progetti si chiude in 1–4 settimane di lavoro.",
        },
        {
          q: "Serve comprare nuovo software?",
          a: "Quasi mai. Se la tua azienda usa Microsoft 365, Power Apps e Power Automate sono spesso già inclusi nelle licenze che paghi. Costruisco prima di tutto su quello che hai.",
        },
        {
          q: "Lavori in sede o da remoto?",
          a: "Entrambi. Sono a Ravenna: in Romagna ed Emilia vengo volentieri in azienda per analisi e formazione. Per il resto d'Italia e per gli integrator lavoro in remoto senza problemi.",
        },
        {
          q: "E dopo la consegna?",
          a: "Ogni progetto include formazione e un periodo di assistenza. Se poi vuoi manutenzione continuativa, la concordiamo a parte — ma l'app resta tua e funziona anche senza di me.",
        },
        {
          q: "Di chi sono i dati?",
          a: "Tuoi, sempre. Tutto resta nei tuoi sistemi e nel tuo tenant Microsoft/cloud. Nessun vincolo con me per accedere ai tuoi dati.",
        },
      ],
    },
    finalCta: {
      title: "Hai un processo che ti fa perdere tempo ogni settimana?",
      copy:
        "Raccontamelo in una chiamata gratuita di 30 minuti. Ti dico subito se si può automatizzare, in quanto tempo e a che costo.",
      button: "Prenota la chiamata gratuita",
      whatsapp: "Oppure scrivimi su WhatsApp",
    },
  },
  en: {
    meta: {
      seoTitle: "Services — Power Platform, Data & Automation for SMEs | Victor Lazari",
      seoDescription:
        "Fixed-price projects for SMEs and system integrators: Power Apps business apps, Power BI dashboards, process automation and data integrations. Ex Baker Hughes. Ravenna & remote.",
    },
    hero: {
      eyebrow: "Services for SMEs and system integrators",
      title: "Concrete projects, fixed price, delivered in weeks.",
      subtitle:
        "No long contracts, no vague promises. Pick one problem, we solve it with tools you probably already own (Microsoft 365), and you measure the result from day one.",
      point1: "Written fixed quote before we start",
      point2: "Typical delivery: 1–3 weeks",
      point3: "I build on the Microsoft licenses you already pay for",
      cta: "Chat on WhatsApp",
      ctaSecondary: "Free intro call",
    },
    offers: {
      title: "What I can do for your company",
      subtitle:
        "Four fixed-scope interventions: you know what you get, what it costs and when it's ready — before signing.",
      timelineLabel: "Typical timeline",
      deliverableLabel: "What you get",
      items: [
        {
          code: "app",
          name: "Custom business app",
          tagline: "Replace Excel, paper and internal WhatsApp with an app built for your process.",
          timeline: "2–3 weeks",
          bullets: [
            "Order approvals, work reports, non-conformities, leave requests: your process, digitized",
            "Built with Power Apps on the Microsoft 365 licenses you already have",
            "Works on phone, tablet and PC — including the shop floor",
            "Centralized data: no more Excel files in 12 different versions",
          ],
          deliverable: "A working app your team actually uses, training included.",
        },
        {
          code: "dashboard",
          name: "Power BI dashboard",
          tagline: "Production, sales, margins: your numbers refreshing themselves, on one screen.",
          timeline: "1–2 weeks",
          bullets: [
            "Connected directly to your ERP, SQL or Excel files",
            "KPIs defined with you: what you check every Monday morning",
            "Automatic refresh: nobody has to 'prepare the report' anymore",
            "Accessible from the office, home and phone",
          ],
          deliverable: "A live dashboard for you and your managers, with verified data.",
        },
        {
          code: "automation",
          name: "Process & report automation",
          tagline: "The repetitive tasks stealing hours from your back office, done by software.",
          timeline: "1–2 weeks",
          bullets: [
            "Recurring reports generated and sent automatically (email, Teams, WhatsApp)",
            "Data flowing between office and production without copy-paste",
            "Automatic alerts: deadlines, thresholds, anomalies",
            "Power Automate + integrations: at Baker Hughes I cut manual work by 60%",
          ],
          deliverable: "Documented automated flows, with measurable man-hours saved.",
        },
        {
          code: "integration",
          name: "Integrations & data migration",
          tagline: "Your systems finally talking to each other: ERP, e-commerce, production.",
          timeline: "2–4 weeks",
          bullets: [
            "Connections between ERP, SQL Server, SharePoint and cloud",
            "Clean data migration: from legacy systems or Excel to a real database",
            "Custom APIs and connectors where software has no built-in integration",
            "Experience with industrial and pharmaceutical data (traceability included)",
          ],
          deliverable: "Connected systems and migrated data, with documentation and tests.",
        },
      ],
    },
    integrators: {
      title: "For system integrators and consultancies",
      text:
        "More Power Platform, data or development projects than hands to deliver them? I work as a subcontractor or white-label: I join projects you've already sold, immediately available, billed per day or fixed-price. Italian, English, Romanian and Russian for international clients.",
      bullets: [
        "Power Apps, Power Automate, Power BI, SQL Server, Azure",
        "Immediately available, also part-time across projects",
        "Enterprise experience: Baker Hughes, pharma and manufacturing",
      ],
      cta: "Ask about availability",
    },
    process: {
      title: "How it works",
      subtitle: "Three steps, zero surprises.",
      steps: [
        {
          title: "1. Free 30-minute call",
          text: "You describe the problem. I tell you right away whether I can solve it, how and in what timeframe — or I honestly say no.",
        },
        {
          title: "2. Written fixed quote",
          text: "Scope, deliverables, timeline and price: everything in writing before we start. No surprise costs.",
        },
        {
          title: "3. Delivery and training",
          text: "I deliver in weeks, not months. I train your team and stay available for support after delivery.",
        },
      ],
    },
    proof: {
      title: "Why trust me",
      stats: [
        { value: "200+", label: "critical business processes supported at Baker Hughes" },
        { value: "−60%", label: "manual work eliminated through automation" },
        { value: "7+", label: "years across manufacturing, pharma and automotive" },
        { value: "4", label: "languages: Italian, English, Romanian, Russian" },
      ],
      companiesLabel: "Experience at companies like",
    },
    faq: {
      title: "Frequently asked questions",
      items: [
        {
          q: "How much does a project cost?",
          a: "It depends on scope, but you know before we start: after the free call you receive a written fixed quote. Most projects take 1–4 weeks of work.",
        },
        {
          q: "Do I need to buy new software?",
          a: "Almost never. If your company uses Microsoft 365, Power Apps and Power Automate are often already included in the licenses you pay. I build on what you have first.",
        },
        {
          q: "On-site or remote?",
          a: "Both. I'm based in Ravenna: across Romagna and Emilia I'm happy to come on-site for analysis and training. For the rest of Italy and for integrators I work fully remote.",
        },
        {
          q: "What happens after delivery?",
          a: "Every project includes training and a support period. If you want ongoing maintenance we agree on it separately — but the app is yours and works without me.",
        },
        {
          q: "Who owns the data?",
          a: "You do, always. Everything stays in your systems and your Microsoft/cloud tenant. No lock-in with me to access your own data.",
        },
      ],
    },
    finalCta: {
      title: "Is there a process wasting your team's time every week?",
      copy:
        "Tell me about it in a free 30-minute call. I'll tell you right away whether it can be automated, how fast and at what cost.",
      button: "Book the free call",
      whatsapp: "Or message me on WhatsApp",
    },
  },
};
